import { capitalize, upperCase } from "lodash";

export const SouthAfricanRand = new Intl.NumberFormat("en-ZA", {
  style: "currency",
  currency: "ZAR",
});

export const CreateUUID = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16),
  );
};

export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) return match[2];
  return null;
};

export const formatCategoryName = (category) => {
  if (!category) return "Products";
  return capitalize(upperCase(category.replaceAll("_", " ")));
};

// Old printed QR codes/URLs encode category/type/vendor/etc. as name strings
// (e.g. "service_parts"), from before the switch to numeric Ids. Anything
// that isn't a plain integer (or "all", when allowed) is that legacy format.
export const isLegacyProductFilterValue = (value, { allowAll = false } = {}) => {
  if (value === null || value === undefined || value === "") return false;
  if (allowAll && String(value).toLowerCase() === "all") return false;
  return !/^\d+$/.test(String(value));
};

// Converts API names like "ADDITIVES_/_TREATMENTS" → "Additives / Treatments"
// and "Brake_System" → "Brake System". Used for display in nav and product pages.
export const formatDisplayName = (name) =>
  (name ?? "")
    .replace(/_\/_/g, " / ")
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/(^|\s|\/)[a-z]/g, (c) => c.toUpperCase());

export const noop = () => {};

// Wires the standard {setStatusInProgress/Success/Failed/Error, setErrorMessage} callback shape most
// PageFunctions calls expect, defaulting every hook but the error reporter to a no-op.
export const makeCallbacks = (onError) => ({
  setStatusInProgress: noop,
  setStatusSuccess: noop,
  setStatusFailed: noop,
  setStatusError: noop,
  setErrorMessage: onError,
});

export const dataUrlToFile = (dataUrl, filename) => {
  const [header, base64] = dataUrl.split(",");
  const mime = header.match(/:(.*?);/)[1];
  const bytes = atob(base64);
  const buf = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) buf[i] = bytes.charCodeAt(i);
  return new File([buf], filename, { type: mime });
};

export const getNameParts = (fullName) =>
  (fullName || "").trim().split(/\s+/).filter(Boolean);

// A single "Full Name" field is sometimes collected where a downstream request wants firstName/lastName
// separately (e.g. the trade-account request ArgusRoleModal submits).
export const splitContactName = (contactName) => {
  const parts = getNameParts(contactName);
  const firstName = parts[0] || "";
  const lastName = parts.slice(1).join(" ") || firstName;
  return { firstName, lastName };
};

// Phone allows a single leading "+" (country code) followed by digits only.
export const sanitizePhone = (value) =>
  value.replace(/[^\d+]/g, "").replace(/(?!^)\+/g, "");

// Digits-only input (VAT numbers, personal ID numbers, etc.).
export const sanitizeDigits = (value) => value.replace(/\D/g, "");

export const toMap = (array, keySelector) => {
  const map = new Map();
  for (const item of array) {
    const key =
      typeof keySelector === "function" ? keySelector(item) : item[keySelector];
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(item);
  }
  return map;
};

